import React, { useEffect } from "react";
const PIXEL_ID = "936276505813173";
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    /* Meta Pixel Code */
    (function (f: Window, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: Fbq = function (...args: unknown[]) {
        if (n.callMethod) {
          n.callMethod(...args);
        } else {
          n.queue?.push(args);
        }
      } as Fbq;
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s?.parentNode?.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq?.("init", PIXEL_ID);
    window.fbq?.("track", "PageView");
  }, []);
  return <noscript data-id="element-37" data-mp="1ido6vqkrq61g">
      <img height="1" width="1" style={{
      display: "none"
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-38" data-mp="1ie7ot7af4ufh" />
    </noscript>;
}